const env = require('../helpers/env.js');
const hasOpenTokSupport = require('./hasOpenTokSupport.js').once;

module.exports = () => hasOpenTokSupport() &&
  (env.isChromiumEdge || ['Chrome', 'Safari', 'Firefox', 'Opera'].includes(env.name));
